import { render, staticRenderFns } from "./edit-participacion-dato-duplicado.vue?vue&type=template&id=57a2187c"
import script from "./edit-participacion-dato-duplicado.vue?vue&type=script&lang=ts"
export * from "./edit-participacion-dato-duplicado.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports